<template>
    <div>
        <div class="input-container col-6">
            <label for="family-nome">Provincia</label>
            
            <MbDictionaryApiSelect 
                v-model="provincia" 
                :namespace="'provincia'"
                :return-only-label="false"
                :return-only-dictionary-id="false"
                url="/api/v1/bado/dictionary/provincia"
            ></MbDictionaryApiSelect>

            <ul class="parsley-errors-list filled" id="parsley-id-18"
                v-if="errors && errors.length > 0">
                <li v-for="(error, index) in errors" :key="index" 
                    class="parsley-required">{{error}}</li>
            </ul>            
        </div>

        <div v-if="value && value.provincia" class="input-container col-6">
            <label for="family-nome">Scuola</label>
            
            <MbScuolaSelectField 
                v-model="scuola" 
                :provincia-dictionary-id="value.provincia.dictionaryId"></MbScuolaSelectField>
        </div>
    </div>
</template>
<script>
import MbDictionaryApiSelect from './MbDictionaryApiSelect.vue';
import MbScuolaSelectField from './MbScuolaSelectField.vue';

export default{
    name: "mb-scuola-select",
    components: {
        MbDictionaryApiSelect,
        MbScuolaSelectField
    },
    props: {
        label: String,
        value: {
            type: Object,
            default(){
                return {
                    provincia: null,
                    scuola: null
                }
            }
        },
        errors: Array
    },
    data() {
        return {
        }
    },
    computed: {
        provincia: {
            get() {
                return this.value ? this.value.provincia : null;
            },
            set(newValue) {
                this.$emit('input', {
                    provincia: newValue,
                    scuola: null
                });
            }
        },
        scuola: {
            get() {
                return this.value ? this.value.scuola : null;
            },
            set(newValue) {
                this.$emit('input', {
                    provincia: this.value ? this.value.provincia : null,
                    scuola: newValue
                });
            }
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
    }
}

</script>
<style scoped>
>>> input{
    border: none;
    border-color: none;
}
</style>